import MainLayout from '@/common/components/layouts/MainLayout';
import LoadingPage from '@/common/pages/LoadingPage';
import { ADJUSTER_REPORT_DAMAGED_LINKS } from '@/modules/adjusterReportModules/adjusterReport/links/damaged/damagedLinks';
import { VehicleImagePreview } from '@/modules/adjusterReportModules/adjusterReport/pages/ImagePreview/vehicleImagePreview';
import SendOfflinePhotos from '@/modules/OfflineFiles/components/SendOfflinePhotos';
import useGetOfflineImages from '@/modules/OfflineFiles/hooks/useGetOfflineImages';
import { useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';

export default function VehicleDamageImagePreviewPage() {
  const [isLoading, setIsLoading] = useState(true);
  const { id, damagedId } = useParams();
  const { getCurrentFileOfflineImages, FileImagesList: imagesList } =
    useGetOfflineImages();
  const navigate = useNavigate();
  const navigateToRepeatCapturing = () => {
    navigate(
      ADJUSTER_REPORT_DAMAGED_LINKS.DAMAGED_IMAGES({
        id: id!,
        damagedId: damagedId!,
      }).ADJUSTER_VEHICLE.takePhotoFlow,
      { replace: true },
    );
  };
  const BackToImagesTab = () => {
    navigate(
      ADJUSTER_REPORT_DAMAGED_LINKS.DAMAGED_IMAGES({
        id: id!,
        damagedId: damagedId!,
      }).imagesTabPage,
      { replace: true },
    );
  };
  useEffect(() => {
    getCurrentFileOfflineImages({ damagedId: damagedId! }).then(() => {
      setIsLoading(false);
    });
  }, []);
  if (isLoading) {
    return <LoadingPage />;
  }
  return (
    <MainLayout title="زیان‌دیده / تصاویر" header="onlyTitleHeader">
      {imagesList?.damagedImages.length ? (
        <SendOfflinePhotos damagedId={damagedId!} />
      ) : (
        <VehicleImagePreview
          BackToImagesTab={BackToImagesTab}
          navigateToRepeatCapturing={navigateToRepeatCapturing}
          userType="damaged"
          userId={damagedId!}
        />
      )}
    </MainLayout>
  );
}
